import React from 'react';
import _ from 'lodash';

import {
  DDadosComboBox,
  DDadosText,
  DDadosTextArea,
  DDadosNumber,
  DDadosDecimal,
  DDadosCheckbox,
  DDadosDate,
  DDadosDateTime,
  DDadosMask,
  DDadosLabel,
  DDadosRadio,
  DDadosRichText,
  DDadosTime,
  DDadosSuggestion,
  DDadosLookup,
  DDadosFile,
  DDadosSwitch,
  DDadosTypeahead,
  DDadosImage,
  DDadosEditor,
  DDadosMultipleSelect,
  DDadosMultipleSelectComboBox,
  DDadosPercentage,
  DDadosPhone
} from '@common/components/ddados';

class DDadosItem extends React.Component {
  constructor(props) {
    super(props);
  }

  getRef() {
    return this.refItem;
  }

  render() {
    switch (this.props.Tipo) {
      case 'text':
        return <DDadosText {...this.props} />;
      case 'number':
        return <DDadosNumber {...this.props} />;
      case 'decimal':
        return <DDadosDecimal {...this.props} />;
      case 'textarea':
        return <DDadosTextArea {...this.props} />;
      case 'combobox':
        return <DDadosComboBox {...this.props} />;
      case 'checkbox':
        return <DDadosCheckbox {...this.props} />;
      case 'date':
        return <DDadosDate {...this.props} />;
      case 'mask':
        return <DDadosMask {...this.props} />;
      case 'label':
        return <DDadosLabel {...this.props} />;
      case 'radio':
        return <DDadosRadio {...this.props} />;
      case 'richtext':
        return <DDadosRichText ref={(el) => (this.refItem = el)} {...this.props} />;
      case 'time':
        return <DDadosTime {...this.props} />;
      case 'suggestion':
        return <DDadosSuggestion {...this.props} />;
      case 'lookup':
        return <DDadosLookup {...this.props} />;
      case 'file':
        return <DDadosFile {...this.props} />;
      case 'image':
        return <DDadosImage {...this.props} />;
      case 'switch':
        return <DDadosSwitch {...this.props} />;
      case 'typeahead':
        return <DDadosTypeahead {...this.props} />;
      case 'editor':
        return <DDadosEditor {...this.props} />;
      case 'multipleselect':
        return <DDadosMultipleSelect {...this.props} />;
      case 'multipleselectcombobox':
        return <DDadosMultipleSelectComboBox {...this.props} />;
      case 'porcentagem':
        return <DDadosPercentage {...this.props} />;
      case 'datetime':
        return <DDadosDateTime {...this.props} />;
      case 'phone':
        return <DDadosPhone {...this.props} />;
      default:
        return <span>Componente não Encontrado</span>;
    }
  }
}

export default DDadosItem;
